import React from "react";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import "./Legal.css";

const Credits = () => {
  return (
    <div>
      <Breadcrumbs title="Credits" />
      <div className="container py-16">
        <div className="legal-content">
          <h2>Website Development Credits</h2>
          <p>
            This website was designed and developed by 
            <a href="https://yassaroooo.nl" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
              Yasar Al Hammami
            </a> © 2025. All structural and functional elements are protected under copyright law.
          </p>

          <h3>Technical Implementation</h3>
          <p>
            Developed using modern web technologies:
          </p>
          <ul>
            <li>React.js framework</li>
            <li>Custom CSS architecture</li>
            <li>Responsive mobile-first design</li>
            <li>Performance optimization techniques</li>
          </ul>

          <h3>Contact the Developer</h3>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:yassarhammami@gmail.com" className="text-blue-600 hover:underline">
              yassarhammami@gmail.com
            </a>
            <br />
            <strong>Website:</strong>{" "}
            <a href="https://yassaroooo.nl" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
              yassaroooo.nl
            </a>
            <br />
            <strong>GitHub:</strong>{" "}
            <a href="https://github.com/yassarooo" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
              github.com/yassarooo
            </a>
            <br />
            <strong>LinkedIn:</strong>{" "}
            <a href="https://www.linkedin.com/in/yassarooo" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
              linkedin.com/in/yassarooo
            </a>
            <br />
            <strong>WhatsApp:</strong>{" "}
            <a href="https://wa.me/31681029565" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
              +31 681 029 565
            </a>
          </p>

          <h3>Content Ownership</h3>
          <p>
            All dental content and patient-facing materials are © 2025 Digitalezahn Praxis. 
            Practice owned by Dr. Hassan Alshoutaiui. Website code and design remain 
            intellectual property of Yasar Al Hammami.
          </p>

          <h3>License Agreement</h3>
          <p>
            Exclusive operational license granted to Digitalezahn Praxis. 
            Code reproduction or reuse requires written permission from the developer.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Credits;